import type { AllRouteEndpoints } from "../routeTypes";
export const engagementUploadAssetCacheKeys: AllRouteEndpoints[] = [
  "/engagement/media_library_data",
  "/engagement/:app_group_id/feature_limitations",
];

/**
 * iframeUploadAssetMessage types used to differentiate between message types
 * @note all types should have a `braze` prefix like `brazeAssetUploadInitPort`
 */
export const iframeUploadAssetMessage = {
  assetUploadInitPort: "brazeAssetUploadInitPort",
  assetUploadProgressUpdate: "brazeAssetUploadProgressUpdate",
} as const;
